/* LMM Collection — Client-JS für den v4.1-Shop-Bereich (#lmmShop).

   Filterung bleibt SHOPIFY-NATIV / SERVERSEITIG (collection.filters): Facetten, Zähler,
   Kaufberater, Quick-Pills, Pagination und Sortierung werden in Liquid gerendert und über
   echte ?filter.*-URLs gesteuert. Es wird NICHTS clientseitig gefiltert oder gezählt.

   PROGRESSIVE ENHANCEMENT (neu): PJAX-Filternavigation. Klicks auf Filterlinks, „Sofort
   lieferbar", Sortierung, Pagination, aktive Filterchips, Quick-Pills, Kaufberater-Buttons
   und Range-„Übernehmen" werden abgefangen, die Ziel-URL geladen und nur die relevanten
   Collection-Teile ausgetauscht (kein voller Reload, Scrollposition bleibt erhalten, URL
   wird per pushState aktualisiert, Zurück/Vor via popstate). Ohne JS oder bei fetch-Fehler
   funktionieren dieselben Links/Formulare als normale Navigation (Fallback).

   PERFORMANCE: Geladen wird NICHT mehr die volle Seite, sondern nur die betroffenen
   Sections über die Shopify Section-Rendering-API (?sections=<haupt>,<hero>) — der Server
   rendert Header/Mega-Menü/Footer nicht mit, Antwort ist ein Bruchteil der Vollseite.
   Dazu: Antwort-Cache (LRU+TTL, macht Zurück/Umschalten sofortig) und Prefetch bei
   Hover/Fokus/Touch auf Filterlinks (der Klick trifft dann meist den Cache). Die
   Section-IDs werden zur Laufzeit aus dem DOM gelesen (funktioniert für Collection UND
   Suche); ohne ermittelbare ID greift der alte Vollseiten-Fetch.

   Weitere, rein kosmetische Funktionen: mobiler Filter-Drawer, Listen-/Kachel-Ansicht,
   B2B-Preisbox (Netto/Gesamt), Mengen-Stepper, Artikelnummer kopieren, Produktvergleich,
   Range-Slider. Alle sind swap-resilient (Delegation bzw. Re-Init nach PJAX). */
(function () {
  'use strict';
  var root = document.getElementById('lmmShop');
  if (!root) return;
  /* JS-Gate: blendet u. a. die Slider-Bedienelemente erst ein, wenn JS läuft. */
  document.documentElement.classList.add('lmm-has-js');

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  /* sr-only Live-Region für Statusmeldungen (Trefferzahl) — außerhalb der Swap-Bereiche. */
  var live = document.createElement('p');
  live.className = 'sr-only';
  live.id = 'lmmCollectionLive';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('aria-atomic', 'true');
  root.appendChild(live);

  var compareRefresh = null;   /* wird von initCompare gesetzt, nach jedem Swap aufgerufen */

  /* =====================================================================
     A) Wiederverwendbare Initialisierer (Start UND nach jedem PJAX-Swap)
     ===================================================================== */

  /* A1) Ansicht Liste/Kacheln (localStorage) — Klicks delegiert, Zustand re-applybar. */
  function savedView() {
    try { var v = localStorage.getItem('lmm-coll-view'); return (v === 'list' || v === 'grid') ? v : null; }
    catch (e) { return null; }
  }
  function applyView(mode) {
    var list = qs('#productList');
    if (list) {
      list.classList.remove('products--list', 'products--grid');
      list.classList.add('products--' + mode);
    }
    qsa('[data-lmm-view]', root).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-lmm-view') === mode ? 'true' : 'false');
    });
    try { localStorage.setItem('lmm-coll-view', mode); } catch (e) {}
  }
  /* Visueller Leuchten-Kartenmodus (card_mode == 'visual_luminaire', Phase C0 2026-09-02):
     #productList trägt data-card-mode="visual_luminaire"; dort gilt immer die Kachelansicht,
     ohne Umschalter. localStorage 'lmm-coll-view' wird in diesem Modus weder gelesen noch
     geschrieben — eine früher bei technischen Collections gespeicherte Listenansicht darf den
     Leuchtenmodus nicht übersteuern. Technische Collections behalten das bisherige Verhalten. */
  function visualCardMode() {
    var list = qs('#productList');
    return !!(list && list.getAttribute('data-card-mode') === 'visual_luminaire');
  }
  function syncView() {
    if (visualCardMode()) {
      var list = qs('#productList');
      list.classList.remove('products--list');
      list.classList.add('products--grid');
      return;
    }
    var v = savedView(); if (v) applyView(v);
  }

  /* TUEV-02 (2026-08-16): Steuersatz des Storefront-Marktes. sections/lmm-collection-list.liquid
     schreibt ihn als data-lmm-vat-rate an #productList; Quelle dort ist snippets/lmm-vat-rate.liquid.
     Vorher stand hier fest 1,19 — im oesterreichischen Kontext ueberschrieb das sogar den bereits
     serverseitig gerenderten Nettopreis wieder mit dem deutschen Satz. 0 % (Schweiz, Norwegen)
     bedeutet Faktor 1: der Bruttopreis IST dort der Nettopreis. */
  function vatFactor() {
    var el = document.getElementById('productList');
    var r = el ? parseFloat(el.getAttribute('data-lmm-vat-rate')) : NaN;
    return 1 + (isFinite(r) && r >= 0 ? r : 19) / 100;
  }

  /* A2) B2B-Preisbox: Netto + Gesamtbetrag × Menge. Idempotent (data-pricebox). */
  function initPriceBox() {
    function euro(v) { return v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    var VAT = vatFactor();
    var hatSteuer = VAT > 1;
    qsa('#productList .prow').forEach(function (row) {
      if (row.getAttribute('data-pricebox') === '1') return;
      var gross = parseFloat(row.getAttribute('data-price'));
      var buy = row.querySelector('.buy');
      var qty = row.querySelector('.qty');
      if (isNaN(gross) || !buy) return;
      row.setAttribute('data-pricebox', '1');
      var net = gross / VAT;
      var netEl = buy.querySelector('[data-net-price]');
      if (netEl && hatSteuer) netEl.textContent = euro(net) + ' €';
      if (!qty) return;
      var tot = document.createElement('p');
      tot.className = 'rowtotal';
      tot.setAttribute('aria-live', 'polite');
      var cartline = buy.querySelector('.cartline');
      if (cartline) buy.insertBefore(tot, cartline); else buy.appendChild(tot);
      var upd = function () {
        var q = Math.min(9999, Math.max(1, parseInt(qty.value, 10) || 1));
        tot.innerHTML = hatSteuer
          ? 'Gesamt: <b>' + euro(gross * q) + ' €</b> inkl. / <b>' + euro(net * q) + ' €</b> exkl. MwSt.'
          : 'Gesamt: <b>' + euro(gross * q) + ' €</b> ohne MwSt.';
      };
      qty.addEventListener('input', upd);
      qty.addEventListener('change', upd);
      upd();
    });
  }

  /* A3) Range-Slider (Kelvin/Watt/Lumen/Abstrahlwinkel) — SERVERSEITIG, idempotent.
     „Übernehmen" navigiert per PJAX zu einer URL mit allen Werten im gewählten Bereich. */
  function initSliders() {
    function nearest(values, x) {
      if (isNaN(x)) { return values[0]; }
      var best = values[0], bd = Math.abs(values[0].n - x);
      for (var i = 1; i < values.length; i++) {
        var d = Math.abs(values[i].n - x);
        if (d < bd) { bd = d; best = values[i]; }
      }
      return best;
    }
    qsa('[data-slider]', root).forEach(function (box) {
      if (box.getAttribute('data-slider-init') === '1') return;
      var param = box.getAttribute('data-param');
      var values;
      try { values = JSON.parse(box.getAttribute('data-values') || '[]'); } catch (e) { values = []; }
      if (!param || values.length < 2) { return; }
      box.setAttribute('data-slider-init', '1');
      values.sort(function (a, b) { return a.n - b.n; });
      var lo = values[0].n, hi = values[values.length - 1].n;
      var rLo = box.querySelector('.r-lo'), rHi = box.querySelector('.r-hi');
      var nLo = box.querySelector('.n-lo'), nHi = box.querySelector('.n-hi');
      var apply = box.querySelector('.slider-apply');
      if (!rLo || !rHi || !nLo || !nHi) { return; }
      rLo.step = 'any'; rHi.step = 'any';
      var curLo = nearest(values, parseFloat(rLo.value)).n;
      var curHi = nearest(values, parseFloat(rHi.value)).n;
      if (curLo > curHi) { var t = curLo; curLo = curHi; curHi = t; }
      function sync() { rLo.value = curLo; rHi.value = curHi; nLo.value = curLo; nHi.value = curHi; }
      sync();
      function fromRange(e) {
        var a = nearest(values, parseFloat(rLo.value)).n;
        var b = nearest(values, parseFloat(rHi.value)).n;
        if (a > b) { if (e.target === rLo) { b = a; } else { a = b; } }
        curLo = a; curHi = b; sync();
      }
      function fromNum() {
        var a = nearest(values, parseFloat(nLo.value)).n;
        var b = nearest(values, parseFloat(nHi.value)).n;
        if (a > b) { var t2 = a; a = b; b = t2; }
        curLo = a; curHi = b; sync();
      }
      rLo.addEventListener('input', fromRange);
      rHi.addEventListener('input', fromRange);
      nLo.addEventListener('change', fromNum);
      nHi.addEventListener('change', fromNum);
      function navigate() {
        var params = new URLSearchParams(window.location.search);
        params.delete(param);
        params.delete('page');
        if (!(curLo <= lo && curHi >= hi)) {
          values.forEach(function (vv) { if (vv.n >= curLo && vv.n <= curHi) { params.append(param, vv.v); } });
        }
        var qsStr = params.toString();
        /* Facette des Sliders als Anker mitgeben (facetKey/anchorTop) — hält die Position nach dem Swap. */
        var det = box.closest('details');
        var t = det ? det.querySelector('.lmf__title') : null;
        pjaxNavigate(window.location.pathname + (qsStr ? '?' + qsStr : ''), {
          source: 'filter',
          anchorKey: t ? norm(t.textContent) : '',
          anchorTop: det ? det.getBoundingClientRect().top : undefined
        });
      }
      if (apply) { apply.addEventListener('click', navigate); }
      [nLo, nHi].forEach(function (inp) {
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); fromNum(); navigate(); } });
      });
    });
  }

  /* A4) Mobiler Filter-Badge (#lmmFilters-Drawer): Anzahl aktiver Filter am „Filter"-Button. */
  function updateMobileCount() {
    var badge = qs('[data-lmf-count]', root);
    if (!badge) return;
    var n = qsa('#lmmActiveChips .lmf-chip', root).length;
    badge.textContent = n > 0 ? String(n) : '';
  }

  /* =====================================================================
     B) Einmalige Setups (Delegation → überleben PJAX-Swaps)
     ===================================================================== */

  /* B1) Ansicht-Umschalter (delegiert). */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lmm-view]');
    if (b && root.contains(b)) { applyView(b.getAttribute('data-lmm-view')); }
  });

  /* B2) Mengen-Stepper (+/−). */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('.qbtn[data-step]');
    if (!b) return;
    var line = b.closest('.cartline');
    var inp = line && line.querySelector('.qty');
    if (!inp) return;
    var step = parseInt(b.getAttribute('data-step'), 10) || 0;
    var min = parseInt(inp.getAttribute('min'), 10) || 1;
    var val = (parseInt(inp.value, 10) || min) + step;
    if (val < min) val = min;
    inp.value = val;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
  });

  /* B3) Artikelnummer kopieren. */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.lmm-copybtn[data-copy]');
    if (!btn) return;
    e.preventDefault();
    var val = btn.getAttribute('data-copy') || '';
    var done = function () {
      btn.classList.add('is-copied');
      var v = btn.querySelector('.cp-v');
      var prev = v ? v.textContent : '';
      if (v) v.textContent = 'kopiert ✓';
      setTimeout(function () { btn.classList.remove('is-copied'); if (v) v.textContent = prev; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(val).then(done).catch(done);
    } else {
      var t = document.createElement('textarea');
      t.value = val;
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t);
      done();
    }
  });

  /* B3p) Produktbezogenes Vorladen der grossen Bilder (Phase E1, 2026-09-04). Gemessen auf der PDP: ohne
     Vorladung kostete jeder Bildwechsel 416-1280 ms, weil das Grossbild erst beim Umschalten geholt wurde;
     assets/lmm-pdp.js loest das seit dem 03.09. mit lmmVorladen() - einem Bildspeicher je URL, decoding
     'async' und einem angestossenen, NIE abgewarteten decode(). Genau dieses Verfahren steht hier, nur mit
     dem Unterschied, dass die Collection-Lightbox EINE feste Variante zeigt (width=1600, kein srcset): der
     Speicherschluessel ist damit zeichengleich die URL, die spaeter in lbImg.src landet - es kann keinen
     Fall geben, in dem eine andere Breite vorgeladen als angezeigt wird.
     Geladen wird ausschliesslich produktbezogen und erst nach erkennbarem Interesse (Zeigen/Fokussieren/
     Druecken der Lupe, Oeffnen der Vorschau, Wechsel eines Karten-Thumbnails) - der normale Seitenaufruf
     holt weiterhin kein einziges grosses Bild. Bei Save-Data oder 2G bleibt es bei aktuellem Bild plus
     direkten Nachbarn. */
  function visHires(u) { return u && u.indexOf('width=830') > -1 ? u.split('width=830').join('width=1600') : u; }
  var visImgCache = Object.create(null);
  function visSparsam() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    var t = c.effectiveType || '';
    return t === 'slow-2g' || t === '2g';
  }
  function visWarm(src) {
    if (!src) return null;
    if (visImgCache[src]) return visImgCache[src];
    var im = new Image();
    im.decoding = 'async';
    /* Dekodieren, sobald die Bytes da sind - die Decodezeit faellt damit VOR den Klick. decode() wird nur
       angestossen und nie abgewartet: in einem verborgenen Dokument loest es gar nicht aus. */
    var dek = function () { if (im.decode) { try { im.decode().catch(function () {}); } catch (e) {} } };
    im.addEventListener('load', dek, { once: true });
    im.src = src;
    if (im.complete && im.naturalWidth > 0) dek();
    visImgCache[src] = im;
    return im;
  }
  /* Rest desselben Produkts im Leerlauf, von der Startposition aus nach aussen, zwei je Leerlaufscheibe -
     dieselbe Staffelung wie die PDP-Galerie. Nur ein Laeufer gleichzeitig: ein neuer Auftrag entwertet den
     alten ueber das Kennzeichen, damit das Ueberfahren mehrerer Karten keine Warteschlangen aufbaut. */
  var visIdleToken = 0;
  function visIdleRest(urls, start) {
    if (visSparsam() || urls.length < 4) return;
    var token = ++visIdleToken;
    var n = urls.length, k = 2;
    var weiter = function () {
      if (token !== visIdleToken) return;
      var getan = 0;
      while (k < n && getan < 2) { visWarm(urls[(start + k + n) % n]); k++; getan++; }
      if (k >= n) return;
      if (window.requestIdleCallback) window.requestIdleCallback(weiter, { timeout: 500 });
      else setTimeout(weiter, 80);
    };
    if (window.requestIdleCallback) window.requestIdleCallback(weiter, { timeout: 800 });
    else setTimeout(weiter, 200);
  }

  /* B3b) Mehrbild-Vorschau der visuellen Leuchtenkarte (Phase D1a.1, 2026-09-03). Klick/Enter/Leertaste auf ein
     Thumbnail (button.vis-thumb) tauscht NUR das grosse Bild derselben Karte: src (830 px), srcset (dieselben sechs
     Breitenstufen wie das Liquid-image_tag, das nicht nach Originalgroesse filtert), alt, width/height (wie image_tag:
     830 x Seitenverhaeltnis; ohne Masse werden die alten Attribute entfernt — die Bildbox ist ohnehin fest 1:1,
     daher kein Layoutsprung); sizes bleibt (gleicher Bildplatz). Kein PDP-Wechsel, keine URL-/Filter-
     aenderung, kein Merkzettel. Delegiert auf root -> ueberlebt PJAX-Swaps ohne Re-Init, keine Listener je Karte.
     Das grosse Bild wird erst hier, also nach der Nutzerinteraktion, geladen.
     Phase E1 (2026-09-04): rollender Tabindex. In der normalen Tabfolge ist je Karte nur noch EIN Thumbnail
     erreichbar (das aktive, tabindex 0), die uebrigen tragen tabindex -1; innerhalb der Gruppe fuehren
     Pfeil links/rechts, Pos1 und Ende zum jeweiligen Bild und zeigen es sofort an (ein Enter-Schritt entfaellt),
     Enter und Leertaste bleiben die native Buttonbedienung. Maus und Touch aendern sich nicht, das Aussehen
     ebenfalls nicht. Der Ausgangszustand steht bereits im Liquid, deshalb stimmt er auch direkt nach einem
     PJAX-Tausch ohne Nachlauf. */
  var VIS_WIDTHS = [160, 240, 320, 420, 560, 830];

  /* B3k) Vorladen der KARTENBILD-Variante (Phase E1.1, 2026-09-04). Auf dem Live-MAIN gemessen: der
     erste Klick auf ein bis dahin nicht gezeigtes Bild kostete 17-763 ms (Median 333, p95 680), und
     die sichtbare Wechselzeit war zeichengleich das Response-Ende GENAU EINES Bildrequests. Grund:
     der Kartenplatz ist 183-221 px breit, der Browser waehlt aus dem srcset also width=320 (bei
     DPR 2 width=560) - eine Variante, die vorher nie geholt wurde und die die Shopify-Bild-CDN beim
     ersten Abruf erst erzeugen muss. Das Vorladen aus B3p betrifft ausschliesslich width=1600, also
     die Lightbox, und half dem Kartenbild deshalb nicht.
     Vorbereitet wird hier dieselbe responsive Auswahl wie am sichtbaren Bild: ein Image() bekommt
     denselben sizes-Wert (aus dem Liquid), dasselbe srcset und denselben src - die Kandidatenwahl
     trifft damit der Browser selbst und nicht dieser Code, eine feste Breite wird nirgends geraten.
     Verfahren und Reihenfolge sind aus assets/lmm-pdp.js (lmmVorladen) uebernommen: decoding
     'async', angestossenes und NIE abgewartetes decode(), genau ein Eintrag je Ziel. Der Schluessel
     traegt zusaetzlich Viewportbreite und DPR, damit nach Drehen oder Groessenaenderung die dann
     gueltige Variante vorbereitet wird; faellt die Wahl erneut auf denselben Kandidaten, trifft der
     zweite Eintrag den Browsercache und erzeugt keinen zweiten Download. Geladen wird ausschliesslich
     produktbezogen nach erkennbarem Interesse an GENAU einer Karte - Seitenaufruf und Scrollen holen
     weiterhin kein einziges Kartenbild zusaetzlich. */
  var visCardCache = Object.create(null);
  var visCardN = 0;
  function visCardSrcset(src) {
    return VIS_WIDTHS.map(function (w) { return src.split('width=830').join('width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  function visCardWarm(src, sizes) {
    if (!src || src.indexOf('width=830') < 0) return null;
    var srcset = visCardSrcset(src);
    var schluessel = srcset + '|' + Math.round(window.innerWidth / 40) + '|' + (window.devicePixelRatio || 1);
    if (visCardCache[schluessel]) return visCardCache[schluessel];
    var im = new Image();
    im.decoding = 'async';
    var dek = function () {
      /* Die tatsaechlich gewaehlte Kandidaten-URL zusaetzlich unter ihrem eigenen Namen ablegen. */
      if (im.currentSrc) visImgCache[im.currentSrc] = im;
      if (im.decode) { try { im.decode().catch(function () {}); } catch (e) {} }
    };
    im.addEventListener('load', dek, { once: true });
    if (sizes) im.sizes = sizes;
    im.srcset = srcset;
    im.src = src;
    if (im.complete && im.naturalWidth > 0) dek();
    if (++visCardN > 400) { visCardCache = Object.create(null); visCardN = 1; }
    visCardCache[schluessel] = im;
    return im;
  }
  /* Bis zu vier Kartenbilder GENAU EINER Karte, beginnend beim naechsten Bild. Bilder ab Nr. 5 bleiben
     aussen vor: sie sind in der Karte nicht anwaehlbar; fuer sie ist weiterhin allein das
     Lightbox-Vorladen aus B3p zustaendig. Bei Save-Data oder 2G nur das angesteuerte Bild und dessen
     Nachfolger. deckel begrenzt zusaetzlich (Ueberfahren der Bildflaeche: nur ein Bild). */
  function visCardWarmAll(card, ziel, deckel) {
    var img = card && card.querySelector('.vis-imgbox img');
    if (!img) return 0;
    var thumbs = qsa('.vis-thumb', card);
    var n = thumbs.length;
    if (n < 2) return 0;
    var sizes = img.getAttribute('sizes') || '';
    var gezielt = (typeof ziel === 'number' && ziel >= 0 && ziel < n);
    var start = 0, a;
    if (gezielt) start = ziel;
    else { for (a = 0; a < n; a++) if (thumbs[a].getAttribute('aria-pressed') === 'true') start = a; }
    var max = visSparsam() ? 1 : (typeof deckel === 'number' ? deckel : n - 1);
    var g = 0, i;
    if (gezielt && visCardWarm(thumbs[ziel].getAttribute('data-src'), sizes)) g++;
    for (i = 1; i < n && i <= max; i++) {
      if (visCardWarm(thumbs[(start + i) % n].getAttribute('data-src'), sizes)) g++;
    }
    return g;
  }

  function visThumbActivate(btn, fokus) {
    var card = btn.closest('.prow--vis');
    var img = card && card.querySelector('.vis-imgbox img');
    if (!img) return;
    var thumbs = qsa('.vis-thumb', card);
    var schonAktiv = btn.getAttribute('aria-pressed') === 'true';
    /* Der rollende Tabindex wird auch dann nachgezogen, wenn dasselbe Thumbnail erneut kommt — sonst
       koennte nach einem Rundlauf ein Element mit tabindex 0 zurueckbleiben, das nicht mehr aktiv ist. */
    thumbs.forEach(function (b) {
      var on = (b === btn);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    if (fokus) { try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); } }
    if (schonAktiv) return;
    var src = btn.getAttribute('data-src') || '';
    if (src.indexOf('width=830') < 0) return;
    var natW = parseInt(btn.getAttribute('data-w'), 10) || 0;
    var natH = parseInt(btn.getAttribute('data-h'), 10) || 0;
    var srcset = visCardSrcset(src);
    var sizes = img.getAttribute('sizes') || '';
    /* Erster bewusster Bildwechsel = Interesse an genau diesem Produkt: die restlichen Kartenbilder
       dieser einen Karte nachziehen, damit das Weiterklicken nicht erneut kalt laeuft. */
    visCardWarmAll(card, thumbs.indexOf(btn));
    var vorlauf = visCardWarm(src, sizes);
    /* Der Tausch selbst: ist die Zielvariante fertig, geschieht er synchron und ist damit nie langsamer
       als vorher. Ist sie es nicht, BLEIBT DAS ALTE BILD STEHEN und der Tausch faellt geschlossen an,
       sobald die Bytes da sind - kein weisser Zwischenzustand, kein Flackern, keine Ladeanzeige. Ein
       spaeterer Klick auf derselben Karte entwertet einen noch offenen Tausch ueber das Kennzeichen. */
    var anwenden = function () {
      if (card.__visZiel !== src) return;
      card.__visZiel = null;
      if (natW > 0 && natH > 0) { img.setAttribute('width', '830'); img.setAttribute('height', String(Math.round(830 * natH / natW))); }
      else { img.removeAttribute('width'); img.removeAttribute('height'); }
      img.setAttribute('alt', btn.getAttribute('data-alt') || '');
      img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
    };
    card.__visZiel = src;
    if (!vorlauf || vorlauf.complete) anwenden();
    else {
      vorlauf.addEventListener('load', anwenden, { once: true });
      vorlauf.addEventListener('error', anwenden, { once: true });
      /* Sicherung: bleibt das Ereignis aus, wird spaetestens nach 1,5 s regulaer getauscht. */
      setTimeout(anwenden, 1500);
    }
    /* Die grosse Variante genau dieses Bildes vorladen. Es ist das Bild, mit dem die Lupe spaeter
       oeffnet — mehr wird hier nicht geholt. */
    if (!visSparsam()) visWarm(visHires(src));
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.vis-thumb[data-src]');
    if (!btn || !root.contains(btn)) return;
    visThumbActivate(btn, false);
  });
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    var btn = e.target.closest && e.target.closest('.vis-thumb[data-src]');
    if (!btn || !root.contains(btn)) return;
    var grp = btn.closest('.vis-thumbs');
    if (!grp) return;
    var thumbs = qsa('.vis-thumb', grp);
    var i = thumbs.indexOf(btn);
    if (i < 0 || thumbs.length < 2) return;
    var z = e.key === 'Home' ? 0
          : e.key === 'End' ? thumbs.length - 1
          : e.key === 'ArrowRight' ? (i + 1) % thumbs.length
          : (i - 1 + thumbs.length) % thumbs.length;
    e.preventDefault();
    visThumbActivate(thumbs[z], true);
  });
  /* Interesse an GENAU einer Karte: Zeigen, Fokussieren oder Druecken im Filmstreifen bereitet dessen
     Kartenbilder vor. Das blosse Ueberfahren der Bildflaeche holt nur das naechste Bild, damit ein
     Mauszug quer ueber das Raster nicht die Bilder von 24 Karten laedt. Delegiert auf root: drei feste
     Listener, unabhaengig von der Kartenzahl und unveraendert nach jedem PJAX-Tausch. Mehrfachaufrufe
     sind kostenlos, visCardWarm liefert einen vorhandenen Eintrag unveraendert zurueck. */
  function visKarteninteresse(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var strip = t.closest('.vis-thumbs');
    if (strip) {
      if (!root.contains(strip)) return;
      var btn = t.closest('.vis-thumb');
      visCardWarmAll(strip.closest('.prow--vis'), btn ? qsa('.vis-thumb', strip).indexOf(btn) : -1);
      return;
    }
    if (e.type !== 'pointerover') return;
    var box = t.closest('.vis-imgbox');
    if (!box || !root.contains(box)) return;
    visCardWarmAll(box.closest('.prow--vis'), -1, 1);
  }
  root.addEventListener('pointerover', visKarteninteresse);
  root.addEventListener('focusin', visKarteninteresse);
  root.addEventListener('pointerdown', visKarteninteresse);

  /* B3c) Große Bildvorschau der visuellen Leuchtenkarte (Phase D1a.3, 2026-09-03). Klick, Enter oder Leertaste
     auf die Lupe (button.vis-zoom) öffnet ein Overlay über der Collection-Seite — ohne Seitenwechsel, ohne
     Reload, ohne URL-Änderung. Markup, Klassennamen, Tastatur-, Swipe- und Fokusverhalten sind aus der
     PDP-Vorschau übernommen (assets/lmm-pdp.js, [data-lmm-zoom]), damit sich beides gleich anfühlt; die Optik
     liefern die zeichengleichen .lmm-lightbox-Regeln in assets/lmm-collection.css. Anders als auf der PDP gibt
     es EINE gemeinsame Instanz für die ganze Seite statt einer je Produkt: sie wird erst beim ersten Öffnen
     gebaut und an <body> gehängt (also außerhalb der PJAX-Tauschbereiche), der Auslöser ist auf root delegiert
     — überlebt Filter-, Sortier- und Seitenwechsel ohne Re-Init und ohne doppelte Listener.
     Bildbestand je Karte: die bis zu vier Thumbnails der Karte (deren data-src ohnehin im DOM steht) plus die
     restlichen Produktbilder aus .vis-more — also alle echten Produktbilder in Shopify-Reihenfolge, nicht nur
     die vier aus dem Filmstreifen. Einzelbildkarte: das Hauptbild. Geladen wird die 1600-px-Variante, und zwar
     ERST nach erkennbarem Interesse an genau diesem Produkt (vor der Interaktion kein einziger zusätzlicher
     Request) — Phase E1 zieht das Holen vom Klick auf das Zeigen/Fokussieren/Drücken der Lupe vor und sichert
     beim Blättern die Nachbarbilder ab (B3p).
     Start auf dem aktuell in der Karte gewählten Bild (aria-pressed am Thumbnail). Schließen per X, Backdrop
     oder ESC; danach Fokus zurück auf die Lupe und exakt dieselbe Scrollposition. Kaufen, Merken, Vergleichen,
     Energie und Datenblatt bleiben unberührt; es werden keine Trackingereignisse ausgelöst. */
  (function visLightbox() {
    var lb = null, lbImg = null, capEl = null, prevBtn = null, nextBtn = null, closeBtn = null, figEl = null;
    var items = [], idx = 0, lastFocus = null, scrollY = 0, idleKarte = null;

    /* Große Variante aus der 830-px-URL der Karte ableiten (gleiche Stufe wie die PDP-Lightbox) — jetzt
       die gemeinsame Funktion visHires aus B3p, damit Vorladen und Anzeigen zeichengleich dieselbe URL
       benutzen. */

    function collect(card) {
      var main = card.querySelector('.vis-imgbox img');
      var t = card.querySelector('.vis-title a');
      var fallbackAlt = (t && norm(t.textContent)) || (main && main.getAttribute('alt')) || '';
      var out = [];
      var thumbs = qsa('.vis-thumb[data-src]', card);
      if (thumbs.length) {
        thumbs.forEach(function (b) { out.push({ src: visHires(b.getAttribute('data-src')), alt: b.getAttribute('data-alt') || fallbackAlt }); });
      } else if (main) {
        out.push({ src: visHires(main.getAttribute('src')), alt: main.getAttribute('alt') || fallbackAlt });
      }
      qsa('.vis-more [data-src]', card).forEach(function (s) {
        out.push({ src: visHires(s.getAttribute('data-src')), alt: s.getAttribute('data-alt') || fallbackAlt });
      });
      return out.filter(function (it) { return it.src; });
    }

    /* Startindex einer Karte = das dort gerade gewaehlte Thumbnail; identisch zu open(). */
    function startIdx(card) {
      var thumbs = qsa('.vis-thumb[data-src]', card);
      var act = card.querySelector('.vis-thumb[aria-pressed="true"]');
      var i = act ? thumbs.indexOf(act) : 0;
      return i > 0 ? i : 0;
    }
    /* Vorladen fuer GENAU dieses Produkt: Prioritaet 1 aktuelles Bild sowie direkter Nachfolger und
       Vorgaenger, Prioritaet 2 das uebernaechste und danach der Rest im Leerlauf. Bei Save-Data/2G bleibt
       es bei Prioritaet 1. Aufgerufen bei Interesse an der Lupe und beim Oeffnen. */
    function warmCard(card) {
      var list = collect(card);
      if (!list.length) return list;
      var urls = list.map(function (it) { return it.src; });
      var n = urls.length, i = startIdx(card);
      visWarm(urls[i]);
      if (n > 1) { visWarm(urls[(i + 1) % n]); visWarm(urls[(i - 1 + n) % n]); }
      if (n > 3 && !visSparsam()) visWarm(urls[(i + 2) % n]);
      /* Der Leerlauf-Nachlauf wird je Karte nur einmal angestossen: pointerover feuert beim Ueberfahren
         mehrfach (Button und SVG sind eigene Ziele), und ein Neustart wuerde den Fortschritt verwerfen. */
      if (card !== idleKarte) { idleKarte = card; visIdleRest(urls, i); }
      return list;
    }
    /* Nach jedem Bildwechsel die naechsten Nachbarn absichern; in Blaetterrichtung zusaetzlich das
       uebernaechste, damit zuegiges Weiterklicken nicht wieder auf einen kalten Request laeuft. */
    function warmNachbarn(dir) {
      var n = items.length;
      if (!n) return;
      visWarm(items[idx].src);
      if (n < 2) return;
      visWarm(items[(idx + 1) % n].src);
      visWarm(items[(idx - 1 + n) % n].src);
      if (dir && n > 3 && !visSparsam()) visWarm(items[(idx + 2 * dir + 2 * n) % n].src);
    }
    function render() {
      var it = items[idx] || { src: '', alt: '' };
      var multi = items.length > 1;
      lbImg.setAttribute('alt', it.alt || '');
      /* Erst in den Bildspeicher, dann tauschen: der Tausch bleibt synchron (das alte Bild steht im
         selben <img> stehen, bis das neue fertig ist — kein leerer Zustand, keine Ladeanimation). */
      visWarm(it.src);
      lbImg.setAttribute('src', it.src);
      capEl.textContent = multi ? (idx + 1) + ' / ' + items.length : '';
      capEl.hidden = !multi;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      warmNachbarn(0);
    }
    function go(d) {
      if (items.length < 2) return;
      idx = (idx + d + items.length) % items.length;
      render();
      warmNachbarn(d);
    }
    function focusable() {
      return [closeBtn, prevBtn, nextBtn].filter(function (b) { return b && b.offsetParent !== null; });
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
      if (e.key === 'Tab') {
        var f = focusable();
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function build() {
      if (lb) return;
      lb = document.createElement('div');
      lb.className = 'lmm-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Produktbild in großer Ansicht');
      lb.hidden = true;
      lb.innerHTML =
        '<div class="lmm-lightbox__backdrop" data-lb-close></div>'
        + '<button type="button" class="lmm-lightbox__close" data-lb-close aria-label="Schließen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
        + '<figure class="lmm-lightbox__fig"><img class="lmm-lightbox__img" alt="" decoding="async">'
        + '<figcaption class="lmm-lightbox__cap" data-lb-cap aria-live="polite"></figcaption></figure>'
        + '<button type="button" class="lmm-lightbox__nav lmm-lightbox__prev" data-lb-prev aria-label="Vorheriges Bild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg></button>'
        + '<button type="button" class="lmm-lightbox__nav lmm-lightbox__next" data-lb-next aria-label="Nächstes Bild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>';
      document.body.appendChild(lb);
      lbImg = lb.querySelector('.lmm-lightbox__img');
      capEl = lb.querySelector('[data-lb-cap]');
      prevBtn = lb.querySelector('[data-lb-prev]');
      nextBtn = lb.querySelector('[data-lb-next]');
      closeBtn = lb.querySelector('.lmm-lightbox__close');
      figEl = lb.querySelector('.lmm-lightbox__fig');
      qsa('[data-lb-close]', lb).forEach(function (el) { el.addEventListener('click', close); });
      prevBtn.addEventListener('click', function () { go(-1); });
      nextBtn.addEventListener('click', function () { go(1); });
      lb.addEventListener('keydown', onKey);
      var x0 = null;
      figEl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      figEl.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (items.length > 1 && Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    function open(card, btn) {
      var list = warmCard(card);
      if (!list.length) return;
      build();
      items = list;
      idx = startIdx(card);
      var t = card.querySelector('.vis-title a');
      var title = t ? norm(t.textContent) : '';
      lb.setAttribute('aria-label', title ? title + ' – Produktbilder in großer Ansicht' : 'Produktbild in großer Ansicht');
      render();
      lastFocus = btn;
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      lb.hidden = false;
      document.documentElement.classList.add('lmm-lightbox-open');
      closeBtn.focus();
    }
    function close() {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.documentElement.classList.remove('lmm-lightbox-open');
      /* Reihenfolge ist wichtig: erst ein Layout erzwingen (das Dokument ist sonst noch nicht wieder
         scrollbar und window.scrollTo bliebe wirkungslos), dann die gemerkte Scrollposition wiederherstellen,
         dann den Fokus OHNE eigenes Scrollen zurueckgeben — sonst zieht focus() die Seite an den Knopf. */
      void document.documentElement.offsetHeight;
      if ((window.pageYOffset || document.documentElement.scrollTop || 0) !== scrollY) window.scrollTo(0, scrollY);
      if (lastFocus && lastFocus.focus) {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
      }
      lastFocus = null;
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vis-zoom]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var card = btn.closest('.prow--vis');
      if (card) open(card, btn);
    });
    /* Interesse an genau einem Produkt: Zeiger auf der Lupe, Tastaturfokus auf der Lupe, Druck auf die
       Lupe (Maus, Stift, Finger). pointerenter/focus steigen nicht auf und taugen deshalb nicht fuer die
       Delegation — pointerover, focusin und pointerdown tun es und ueberleben damit jeden PJAX-Tausch.
       Mehrfachaufrufe sind kostenlos: visWarm liefert den bereits vorhandenen Bildeintrag zurueck. */
    var interesse = function (e) {
      var btn = e.target.closest && e.target.closest('[data-vis-zoom]');
      if (!btn || !root.contains(btn)) return;
      var card = btn.closest('.prow--vis');
      if (card) warmCard(card);
    };
    root.addEventListener('pointerover', interesse);
    root.addEventListener('focusin', interesse);
    root.addEventListener('pointerdown', interesse);
  })();

  /* B4) Mobiler Filter-Drawer (Off-Canvas) — delegiert, damit getauschte Buttons funktionieren.
     #lmmFilters-Element bleibt erhalten (nur sein innerHTML wird bei PJAX getauscht). */
  (function drawer() {
    var box = qs('#lmmFilters');
    if (!box) return;
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
    function focusables() {
      return Array.prototype.filter.call(box.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') { return; }
      var f = focusables();
      if (!f.length) { return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function openBtnEl() { return qs('[data-lmf-open]', root); }
    function open() {
      root.classList.add('lmf-open');
      var bd = qs('.lmf-backdrop'); if (bd) { bd.hidden = false; }   /* Backdrop einblenden */
      var ob = openBtnEl(); if (ob) ob.setAttribute('aria-expanded', 'true');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      document.body.style.overflow = 'hidden';
      var c = box.querySelector('[data-lmf-close]');
      if (c) { c.focus(); }
      document.addEventListener('keydown', onKey);
    }
    function close() {
      root.classList.remove('lmf-open');
      var bd = qs('.lmf-backdrop'); if (bd) { bd.hidden = true; }   /* Backdrop ausblenden */
      var ob = openBtnEl(); if (ob) ob.setAttribute('aria-expanded', 'false');
      box.removeAttribute('role');
      box.removeAttribute('aria-modal');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      var ob2 = openBtnEl(); if (ob2) { try { ob2.focus(); } catch (e) {} }
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-lmf-open]')) { open(); }
      else if (e.target.closest('[data-lmf-close]')) { close(); }
    });
    /* offen lassen für PJAX: drawerIsOpen() prüft die Klasse. */
    root._lmfDrawerOpen = function () { return root.classList.contains('lmf-open'); };
  })();

  /* B5) Produktvergleich (Port v4.1): bis zu 4 Produkte → Modal mit Spec-Gegenüberstellung.
     Tray/Modal liegen außerhalb der Swap-Bereiche; nur die Checkboxen (.cmp-cb) erneuern sich
     bei PJAX → compareRefresh() wird nach jedem Swap aufgerufen (Auswahl wird zurückgesetzt). */
  (function initCompare() {
    var tray = document.getElementById('cmpTray');
    var modal = document.getElementById('cmpModal');
    var body = document.getElementById('cmpModalBody');
    if (!tray || !modal || !body) { return; }
    var countEl = document.getElementById('cmpCount');
    var openBtn = document.getElementById('cmpOpen');
    var clearBtn = document.getElementById('cmpClear');
    var status = document.getElementById('cmpStatus');
    var MAX = 4;
    function cbList() { return Array.prototype.slice.call(document.querySelectorAll('.cmp-cb')); }
    function euro(v) { return v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function announce(m) { if (status) { status.textContent = ''; status.textContent = m; } }
    function checked() { return cbList().filter(function (c) { return c.checked; }); }
    function selectedRows() { return checked().map(function (c) { return c.closest('.prow'); }); }
    function refresh() {
      var cbs = cbList();
      var n = cbs.filter(function (c) { return c.checked; }).length;
      if (countEl) { countEl.textContent = n; }
      tray.hidden = (n === 0);
      if (openBtn) { openBtn.disabled = (n < 2); }
      document.body.classList.toggle('has-cmp-tray', n > 0);
      cbs.forEach(function (c) { c.disabled = (!c.checked && n >= MAX); });
    }
    compareRefresh = refresh;
    function dimTxt(r) { var d = r.getAttribute('data-dimmable'); return d === 'true' ? 'ja' : (d === 'false' ? 'nein' : '–'); }
    var SPECS = [
      { l: 'Preis (netto)', g: function (r) { var p = parseFloat(r.getAttribute('data-price')); return isFinite(p) ? euro(p / vatFactor()) + ' €' : '–'; } },
      { l: 'Preis (brutto)', g: function (r) { var p = parseFloat(r.getAttribute('data-price')); return isFinite(p) ? euro(p) + (vatFactor() > 1 ? ' € inkl.' : ' € ohne MwSt.') : '–'; } },
      { l: 'Hersteller', g: function (r) { return r.getAttribute('data-vendor') || '–'; } },
      { l: 'Lichtfarbe', g: function (r) { return r.getAttribute('data-lightcolor') || '–'; } },
      { l: 'Farbtemperatur', g: function (r) { var v = r.getAttribute('data-kelvin'); return v ? v + ' K' : '–'; } },
      { l: 'Farbcode', g: function (r) { return r.getAttribute('data-colorcode') || '–'; } },
      { l: 'Lichtstrom', g: function (r) { var v = r.getAttribute('data-lumen'); return v ? v + ' lm' : '–'; } },
      { l: 'Leistung', g: function (r) { var v = r.getAttribute('data-watt'); return v ? (v + ' W').replace('.', ',') : '–'; } },
      { l: 'ersetzt', g: function (r) { var v = parseFloat(r.getAttribute('data-rwatt')); return isFinite(v) ? '~' + Math.round(v) + ' W' : '–'; } },
      { l: 'Abstrahlwinkel', g: function (r) { var v = r.getAttribute('data-beam'); return v ? v + ' °' : '–'; } },
      { l: 'Dimmbar', g: dimTxt },
      { l: 'Energieklasse', g: function (r) { var e = r.querySelector('.eek'); return e ? (e.textContent || '').trim() : '–'; } },
      { l: 'Sockel', g: function (r) { return r.getAttribute('data-base') || '–'; } },
      { l: 'Länge', g: function (r) { return r.getAttribute('data-len') || '–'; } },
      { l: 'Betriebsart', g: function (r) { return r.getAttribute('data-ballast') || '–'; } },
      { l: 'Art.-Nr.', g: function (r) { var c = r.querySelector('.copybtn[data-copy], [data-copy]'); return c ? c.getAttribute('data-copy') : '–'; } }
    ];
    var GEEIGNET = {
      'extra warmweiß': 'Wohnen – sehr warmes, gemütliches Licht',
      'warmweiß': 'Wohn- & Essbereiche',
      'kaltweiß': 'Küche, Bad, Arbeitsplätze – klares Licht',
      'Tageslicht': 'Werkstatt & Detailarbeit',
      'RGBW': 'Stimmungslicht & Farbwechsel'
    };
    function build() {
      var sel = selectedRows();
      function leaders(attr, dir) {
        var vals = sel.map(function (r) { var v = parseFloat(r.getAttribute(attr)); return isFinite(v) ? v : null; });
        var present = vals.filter(function (v) { return v !== null; });
        if (present.length < 2) { return sel.map(function () { return false; }); }
        var best = dir === 'min' ? Math.min.apply(null, present) : Math.max.apply(null, present);
        var other = dir === 'min' ? Math.max.apply(null, present) : Math.min.apply(null, present);
        if (best === other) { return sel.map(function () { return false; }); }
        return vals.map(function (v) { return v !== null && v === best; });
      }
      var cheap = leaders('data-price', 'min');
      var bright = leaders('data-lumen', 'max');
      var efficient = leaders('data-watt', 'min');
      var replaceW = leaders('data-rwatt', 'max');
      var wide = leaders('data-beam', 'max');
      var narrow = leaders('data-beam', 'min');
      var dimVals = sel.map(function (r) { return r.getAttribute('data-dimmable') === 'true'; });
      var dimMixed = dimVals.some(function (d) { return d; }) && dimVals.some(function (d) { return !d; });
      function strengths(i, r) {
        var out = [];
        if (cheap[i]) { out.push('günstigster Preis'); }
        if (bright[i]) { out.push('höchste Helligkeit (' + r.getAttribute('data-lumen') + ' lm)'); }
        if (efficient[i]) { out.push('niedrigste Leistung (' + (r.getAttribute('data-watt') + ' W').replace('.', ',') + ')'); }
        if (replaceW[i]) { out.push('ersetzt am meisten (~' + Math.round(parseFloat(r.getAttribute('data-rwatt'))) + ' W)'); }
        if (wide[i]) { out.push('breite Ausleuchtung (' + r.getAttribute('data-beam') + '°)'); }
        else if (narrow[i]) { out.push('enger Akzent-Strahl (' + r.getAttribute('data-beam') + '°)'); }
        if (dimMixed && dimVals[i]) { out.push('dimmbar'); }
        return out;
      }
      var head = '<thead><tr><th scope="col" class="cmp-c-lbl"></th>';
      sel.forEach(function (r) {
        var img = r.querySelector('.media img');
        var h3 = r.querySelector('.main h3');
        var name = h3 ? (h3.textContent || '').trim() : '';
        var src = img ? (img.getAttribute('src') || '') : '';
        head += '<th scope="col"><span class="cmp-th"><img src="' + esc(src) + '" alt="" width="52" height="52" loading="lazy"><span class="cmp-th-name">' + esc(name) + '</span></span></th>';
      });
      head += '</tr></thead>';
      var verdict = '<tr class="cmp-verdict"><th scope="row">Stärken</th>';
      sel.forEach(function (r, i) {
        var s = strengths(i, r);
        verdict += '<td>' + (s.length ? '<ul class="cmp-str">' + s.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '<span class="cmp-none">ausgewogen – kein Spitzenwert</span>') + '</td>';
      });
      verdict += '</tr>';
      var fit = '<tr class="cmp-fit"><th scope="row">Geeignet für</th>';
      sel.forEach(function (r) { fit += '<td>' + esc(GEEIGNET[r.getAttribute('data-lightcolor')] || '–') + '</td>'; });
      fit += '</tr>';
      var rowsHtml = '';
      SPECS.forEach(function (s) {
        var vals = sel.map(s.g);
        /* Zeile ohne einen einzigen Wert (z. B. Länge bei Glühlampen) entfällt. */
        if (vals.every(function (v) { return v === '–' || v === ''; })) { return; }
        var diff = vals.some(function (v) { return v !== vals[0]; });
        rowsHtml += '<tr' + (diff ? ' class="is-diff"' : '') + '><th scope="row">' + s.l + '</th>';
        vals.forEach(function (v) { rowsHtml += '<td>' + esc(v) + '</td>'; });
        rowsHtml += '</tr>';
      });
      body.innerHTML = '<div class="cmp-modal__scroll"><table class="cmp-compare">' + head + '<tbody>' + verdict + fit + rowsHtml + '</tbody></table></div>'
        + '<p class="cmp-modal__hint">„Stärken" zeigen, wo ein Artikel im Vergleich der gewählten Produkte führt; „Geeignet für" richtet sich nach der Lichtfarbe. Rot markierte Zeilen unterscheiden sich. Alle Werte stammen aus den Artikeldaten.</p>';
    }
    function onKey(e) { if (e.key === 'Escape') { closeModal(); } }
    function openModal() {
      if (checked().length < 2) { return; }
      build();
      modal.hidden = false;
      var c = modal.querySelector('.cmp-modal__close');
      if (c) { c.focus(); }
      document.addEventListener('keydown', onKey);
    }
    function closeModal() {
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (openBtn) { openBtn.focus(); }
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('cmp-cb')) { return; }
      if (t.checked && checked().length > MAX) {
        t.checked = false;
        announce('Maximal ' + MAX + ' Produkte gleichzeitig vergleichbar.');
      }
      refresh();
    });
    if (clearBtn) { clearBtn.addEventListener('click', function () { cbList().forEach(function (c) { c.checked = false; c.disabled = false; }); refresh(); }); }
    if (openBtn) { openBtn.addEventListener('click', openModal); }
    modal.querySelectorAll('[data-cmp-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    refresh();
  })();

  /* =====================================================================
     C) PJAX-Filternavigation (Progressive Enhancement)
     ===================================================================== */
  var SUPPORTS_PJAX = !!(window.fetch && window.history && window.history.pushState && window.DOMParser && window.URL);
  /* Bereiche, die nach einer Filteraktion ausgetauscht werden (innerHTML). Müssen IMMER
     vorhanden sein (stabile Container, Inhalt variabel). */
  /* Pflichtziele MÜSSEN in altem + neuem Dokument existieren (sonst kein gültiger Collection-Swap →
     Fallback normale Navigation). */
  var SWAP_REQUIRED = ['#lmmMain', '#lmmFilters'];
  var navSeq = 0;   /* Stale-Response-Schutz: nur die jüngste Navigation darf den DOM tauschen. */

  /* Section-Rendering-IDs zur Laufzeit aus dem DOM: Haupt-Section (#lmmShop) + Hero-Section
     (#lmmHeroCount, separate Section). Funktioniert für Collection UND Suche, auch im
     Theme-Editor (IDs stehen am .shopify-section-Wrapper). */
  function sectionIdOf(el) {
    var s = el ? el.closest('.shopify-section') : null;
    return s && s.id && s.id.indexOf('shopify-section-') === 0 ? s.id.slice(16) : '';
  }
  var MAIN_SECTION_ID = sectionIdOf(root);
  var HERO_SECTION_ID = sectionIdOf(qs('#lmmHeroCount'));

  /* Antwort-Cache (LRU + TTL): Zurück-Filtern/Umschalten trifft den Cache und swappt sofort;
     TTL begrenzt, wie lange Bestände/Preise aus dem Cache gezeigt werden. pendingFetch teilt
     einen laufenden Prefetch mit dem Klick (kein doppelter Request). */
  var sectionCache = new Map();   /* url -> { main, hero, t } */
  var pendingFetch = new Map();   /* url -> Promise */
  var CACHE_MAX = 30;
  var CACHE_TTL = 300000;         /* 5 min */

  function cacheGet(url) {
    var e = sectionCache.get(url);
    if (!e) { return null; }
    if (Date.now() - e.t > CACHE_TTL) { sectionCache.delete(url); return null; }
    return e;
  }
  function cachePut(url, entry) {
    entry.t = Date.now();
    sectionCache.delete(url);
    sectionCache.set(url, entry);
    if (sectionCache.size > CACHE_MAX) { sectionCache.delete(sectionCache.keys().next().value); }
  }
  function sectionsUrl(url) {
    var u = new URL(url, window.location.href);
    u.searchParams.set('sections', HERO_SECTION_ID ? MAIN_SECTION_ID + ',' + HERO_SECTION_ID : MAIN_SECTION_ID);
    return u.toString();
  }
  function fetchSections(url) {
    var hit = cacheGet(url);
    if (hit) { return Promise.resolve(hit); }
    if (pendingFetch.has(url)) { return pendingFetch.get(url); }
    /* WICHTIG: KEIN Accept:application/json-Header — damit beantwortet Shopify die
       Collection-URL als Collection-JSON-API ({"collection":…}) und ignoriert den
       sections-Parameter. Ohne Accept kommt die Section-Rendering-Antwort
       ({"<section-id>":"<html>"}). */
    var p = window.fetch(sectionsUrl(url), { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); })
      .then(function (json) {
        var entry = { main: json[MAIN_SECTION_ID] || '', hero: HERO_SECTION_ID ? (json[HERO_SECTION_ID] || '') : '' };
        if (!entry.main) { throw new Error('Section fehlt in der Antwort'); }
        cachePut(url, entry);
        return entry;
      });
    pendingFetch.set(url, p);
    p.then(function () { pendingFetch.delete(url); }, function () { pendingFetch.delete(url); });
    return p;
  }

  /* Sortieren quittiert sofort; Filter behalten die kurze Ladeverzögerung. */
  var loadingTimer = 0;
  var sortFlashTimer = 0;
  function topProductIds() {
    return qsa('#productList article.prow').slice(0, 2).map(function (card) {
      return card.getAttribute('data-product-id') || card.getAttribute('data-sku') || '';
    }).filter(Boolean);
  }
  function setLoading(on, immediate) {
    var list = qs('#productList');
    if (list) { list.setAttribute('aria-busy', on ? 'true' : 'false'); }
    if (on && immediate) {
      if (loadingTimer) { window.clearTimeout(loadingTimer); loadingTimer = 0; }
      if (sortFlashTimer) { window.clearTimeout(sortFlashTimer); sortFlashTimer = 0; }
      root.classList.add('is-pjax-loading');
      live.textContent = 'Sortierung wird angewendet …';
    } else if (on) {
      if (!loadingTimer) { loadingTimer = window.setTimeout(function () { loadingTimer = 0; root.classList.add('is-pjax-loading'); }, 120); }
    } else {
      if (loadingTimer) { window.clearTimeout(loadingTimer); loadingTimer = 0; }
      root.classList.remove('is-pjax-loading');
    }
  }

  function facetKey(d) { var t = d.querySelector('.lmf__title'); return t ? norm(t.textContent) : ''; }
  function recordOpenFacets() {
    var map = {};
    qsa('#lmmFacets details', root).forEach(function (d) { var k = facetKey(d); if (k) { map[k] = d.open; } });
    map.subgroups = {};
    qsa('#lmmFacets .lmf-grp[data-subgrp]', root).forEach(function (grp) {
      map.subgroups[grp.getAttribute('data-subgrp')] = grp.classList.contains('is-open');
    });
    return map;
  }
  function restoreOpenFacets(map) {
    qsa('#lmmFacets details', root).forEach(function (d) {
      var k = facetKey(d);
      if (k && Object.prototype.hasOwnProperty.call(map, k)) { d.open = map[k] || d.classList.contains('is-active'); }
    });
    qsa('#lmmFacets .lmf-grp[data-subgrp]', root).forEach(function (grp) {
      var open = grp.classList.contains('is-open') || !!(map.subgroups && map.subgroups[grp.getAttribute('data-subgrp')]);
      grp.classList.toggle('is-open', open);
      var btn = grp.querySelector('[data-subgrp-toggle]');
      var sub = grp.querySelector('.lmf-grp__sub');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (sub) sub.hidden = !open;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-subgrp-toggle]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    e.stopPropagation();
    var grp = btn.closest('.lmf-grp');
    if (!grp) return;
    var sub = grp.querySelector('.lmf-grp__sub');
    var open = grp.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (sub) sub.hidden = !open;
  });

  function swapAll(mainDoc, heroDoc) {
    /* Pflichtziele in BEIDEN Dokumenten vorhanden? Sonst kein gültiger Collection-Swap. */
    for (var i = 0; i < SWAP_REQUIRED.length; i++) {
      if (!qs(SWAP_REQUIRED[i]) || !mainDoc.querySelector(SWAP_REQUIRED[i])) { return false; }
    }
    SWAP_REQUIRED.forEach(function (sel) { qs(sel).innerHTML = mainDoc.querySelector(sel).innerHTML; });
    /* Quick-Pills leben in der Haupt-Section: hidden-Zustand des NEUEN Dokuments übernehmen —
       NICHT pauschal einblenden; fehlt der Block im neuen Zustand → leeren/verstecken. */
    var qf = qs('#lmmQuickFilters');
    if (qf) {
      var nqf = mainDoc.querySelector('#lmmQuickFilters');
      if (nqf) { qf.innerHTML = nqf.innerHTML; qf.hidden = nqf.hidden; }
      else { qf.innerHTML = ''; qf.hidden = true; }
    }
    /* Hero-Badge kommt aus der separat gerenderten Hero-Section; auf Kategorieseiten (.cat-hero)
       bleibt #lmmHeroCount dauerhaft ausgeblendet (Vorgabe 24.10.2026). */
    var hc = qs('#lmmHeroCount');
    if (hc && heroDoc && !hc.closest('.cat-hero')) {
      var nhc = heroDoc.querySelector('#lmmHeroCount');
      if (nhc) { hc.innerHTML = nhc.innerHTML; hc.hidden = nhc.hidden; }
    }
    /* Andere LMM-Module über den DOM-Tausch informieren: Die neuen Karten bringen leere
       Widget-Container mit (REVIEWS.io-Sterne in lmm-reviews.js), die nach dem Swap neu
       befüllt werden müssen — sonst verschwinden die Sterne beim Sortieren/Filtern. */
    try { document.dispatchEvent(new CustomEvent('lmm:content-swapped', { detail: { root: '#lmmMain' } })); }
    catch (e) { /* still */ }
    return true;
  }

  function resultsTopOffset() {
    var header = document.getElementById('header-group');
    if (!header) return 80;
    var position = window.getComputedStyle(header).position;
    return position === 'sticky' || position === 'fixed' ? Math.max(80, header.getBoundingClientRect().height + 12) : 80;
  }
  function scrollToResults() {
    var t = qs('#lmmMain .toolbar') || qs('#productList') || qs('#lmmMain');
    if (!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - resultsTopOffset();
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      scrollByInstant(window, Math.max(0, y) - window.pageYOffset);
      return;
    }
    try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, Math.max(0, y)); }
  }

  function announce() {
    var cards = qsa('#productList article.prow');
    if (cards.length) { live.textContent = cards.length + ' Artikel angezeigt.'; }
  }

  /* „Signatur" des geklickten Bedienelements, um den Fokus nach dem Swap sinnvoll wieder zu
     setzen (ohne nach oben zu springen). */
  function signatureOf(a) {
    if (!a) return null;
    if (a.classList.contains('lmf-instock')) return { kind: 'instock' };
    var cls = a.classList.contains('dopt') ? 'dopt'
            : a.classList.contains('lmf__opt') ? 'lmf__opt'
            : a.classList.contains('subchip') ? 'subchip'
            : a.classList.contains('lmm-pagination__link') ? 'pag'
            : a.classList.contains('lmf-active__reset') ? 'reset' : '';
    var det = a.closest('details');
    return { kind: 'link', cls: cls, txt: norm(a.textContent), facet: det ? facetKey(det) : '' };
  }
  function findBySignature(sig) {
    if (!sig) return null;
    if (sig.kind === 'instock') { return qs('.lmf-instock', root); }
    if (sig.kind === 'link') {
      var cands = qsa('#lmmShop a');
      for (var i = 0; i < cands.length; i++) {
        var c = cands[i];
        if (sig.cls && !c.classList.contains(sig.cls === 'pag' ? 'lmm-pagination__link' : sig.cls)) continue;
        if (norm(c.textContent) !== sig.txt) continue;
        if (sig.facet) { var d = c.closest('details'); if (!d || facetKey(d) !== sig.facet) continue; }
        return c;
      }
    }
    return null;
  }
  function facetElByKey(key) {
    if (!key) { return null; }
    var list = qsa('#lmmFacets details', document);
    for (var i = 0; i < list.length; i++) { if (facetKey(list[i]) === key) { return list[i]; } }
    return null;
  }
  /* Sofortiges (nicht animiertes) Nachscrollen: base.css setzt scroll-behavior:smooth
     global — für die Anker-Korrektur temporär auf 'auto', sonst rutscht die Seite
     sichtbar nach statt still an Ort und Stelle zu bleiben. */
  function scrollByInstant(container, delta) {
    if (!delta) { return; }
    var target = container === window ? (document.scrollingElement || document.documentElement) : container;
    var prev = target.style.scrollBehavior;
    target.style.scrollBehavior = 'auto';
    if (container === window) { window.scrollBy(0, delta); } else { container.scrollTop += delta; }
    target.style.scrollBehavior = prev;
  }

  function pjaxNavigate(url, opts) {
    opts = opts || {};
    if (!SUPPORTS_PJAX) { window.location.href = url; return; }
    var mySeq = ++navSeq;   /* Stale-Response-Schutz: nur die jüngste Navigation tauscht den DOM. */
    var prevY = window.pageYOffset;
    var filtersEl = qs('#lmmFilters');
    var drawerOpen = root.classList.contains('lmf-open');
    var filtersScroll = filtersEl ? filtersEl.scrollTop : 0;
    setLoading(true, opts.source === 'sort');
    /* Bevorzugt Section-Rendering (klein + gecacht + prefetchbar); ohne ermittelbare
       Section-ID der alte Vollseiten-Fetch. Überholte Antworten laufen bewusst weiter
       (füllen den Cache), nur der DOM-Swap ist per navSeq geschützt. */
    var docsPromise;
    if (MAIN_SECTION_ID) {
      docsPromise = fetchSections(url).then(function (entry) {
        return {
          main: new DOMParser().parseFromString(entry.main, 'text/html'),
          hero: entry.hero ? new DOMParser().parseFromString(entry.hero, 'text/html') : null
        };
      });
    } else {
      docsPromise = window.fetch(url, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return { main: doc, hero: doc };
        });
    }
    docsPromise
      .then(function (docs) {
        if (mySeq !== navSeq) { return; }   /* durch neueren Klick abgelöst → Antwort verwerfen */
        var prevTopIds = topProductIds();
        var openFacets = recordOpenFacets();
        if (!swapAll(docs.main, docs.hero)) { throw new Error('Swap-Ziele fehlen'); }
        restoreOpenFacets(openFacets);
        syncView();
        initPriceBox();
        initSliders();
        if (compareRefresh) { compareRefresh(); }
        updateMobileCount();
        if (drawerOpen) { var ob = qs('[data-lmf-open]', root); if (ob) { ob.setAttribute('aria-expanded', 'true'); } }
        if (opts.push !== false) { try { window.history.pushState({ lmmPjax: true }, '', url); } catch (e) {} }
        setLoading(false);
        if (opts.source !== 'sort') { announce(); }
        /* Scrollverhalten */
        if (opts.source === 'pagination') {
          if (opts.keepScroll) {
            /* Obere Pagination: Position halten, nicht zur Ergebnisliste springen. */
            var maxYp = Math.max(0, (document.documentElement.scrollHeight || 0) - window.innerHeight);
            scrollByInstant(window, Math.min(prevY, maxYp) - window.pageYOffset);
          } else {
            scrollToResults();
          }
          /* Fokus an den ANFANG der Ergebnisse (NICHT der untere Pagination-Link,
             der sonst das Fenster ans Seitenende ziehen würde). */
          var rc = qs('#lmmResultCount');
          if (rc) { rc.setAttribute('tabindex', '-1'); try { rc.focus({ preventScroll: true }); } catch (e) {} }
        } else {
          /* Position halten; wurde die (gefilterte) Seite kürzer als die alte Scrollposition,
             nicht ans neue Seitenende springen, sondern zur Toolbar/Ergebnisliste. */
          var maxY = Math.max(0, (document.documentElement.scrollHeight || 0) - window.innerHeight);
          if (prevY <= maxY) { scrollByInstant(window, prevY - window.pageYOffset); } else { scrollToResults(); }
          if (drawerOpen) {
            var nf = qs('#lmmFilters');
            if (nf) { nf.scrollTop = filtersScroll; }
          }
          if (opts.source === 'sort') {
            live.textContent = 'Sortierung angewendet.';
            var toolbar = qs('#lmmMain .toolbar');
            if (toolbar) {
              var toolbarRect = toolbar.getBoundingClientRect();
              if (toolbarRect.top < resultsTopOffset() || toolbarRect.top > window.innerHeight * 0.45) { scrollToResults(); }
            }
            var ss = qs('[data-lmm-sort]', root);
            var isTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
            if (ss) { try { if (isTouch) { ss.blur(); } else { ss.focus({ preventScroll: true }); } } catch (e) {} }
          } else {
            /* Anker-Korrektur gegen Layout-Shift: die geklickte Facette (bzw. das Bedien-
               element) steht nach dem Swap wieder an derselben BILDSCHIRM-Position wie beim
               Klick — auch wenn oberhalb die Aktiv-Chips-Box erscheint/verschwindet oder
               Facetten Werte gewinnen/verlieren. Desktop scrollt das Fenster nach, der
               offene Mobil-Drawer seinen eigenen Filterkasten. Wird der Anker im neuen
               Zustand nicht wiedergefunden, bleibt das bisherige Verhalten (Fensterposition). */
            var focusEl = findBySignature(opts.sig);
            if (typeof opts.anchorTop === 'number') {
              var anchorEl = opts.anchorKey ? facetElByKey(opts.anchorKey) : null;
              if (!anchorEl && opts.sig && opts.sig.facet) { anchorEl = facetElByKey(opts.sig.facet); }
              if (!anchorEl) { anchorEl = focusEl; }
              if (anchorEl) {
                var delta = Math.round(anchorEl.getBoundingClientRect().top - opts.anchorTop);
                var nf2 = qs('#lmmFilters');
                if (drawerOpen && nf2 && nf2.contains(anchorEl)) { scrollByInstant(nf2, delta); }
                else if (Math.abs(delta) > 1) { scrollByInstant(window, delta); }
              }
            }
            if (focusEl) { try { focusEl.focus({ preventScroll: true }); } catch (e) {} }
          }
        }
      })
      .catch(function (err) {
        if (mySeq !== navSeq) { return; }   /* abgelöst → ignorieren (NICHT hart navigieren) */
        /* Fallback: normale Navigation, keine kaputte Seite. */
        window.location.href = url;
      });
  }

  /* Prüft, ob ein Link eine Collection-interne Filternavigation ist, und liefert dann seine
     URL (sonst ''). Von Click-Handler UND Prefetch gemeinsam genutzt — identische Regeln. */
  function pjaxUrlOf(a) {
    if (!a || !root.contains(a)) { return ''; }
    if (a.hasAttribute('data-copy')) { return ''; }                 /* Kopier-Button */
    if (a.closest('.sidebox.cats')) { return ''; }                  /* Kategorie-Navigation → andere Seite */
    if (a.target && a.target !== '' && a.target !== '_self') { return ''; }
    var rawHref = a.getAttribute('href');
    if (!rawHref || rawHref.charAt(0) === '#') { return ''; }       /* reiner Anker-Sprung → normal */
    var dest;
    try { dest = new URL(a.href, window.location.href); } catch (err) { return ''; }
    if (dest.origin !== window.location.origin) { return ''; }      /* extern */
    if (dest.pathname !== window.location.pathname) { return ''; }  /* andere Collection/Produkt → normal */
    if (dest.hash && dest.search === window.location.search) { return ''; } /* gleicher Filterzustand, nur Anker */
    return a.href;
  }

  if (SUPPORTS_PJAX) {
    /* C1) Klicks auf Collection-interne Links abfangen (Filter, Toggle, Chips, Quick-Pills,
       Kaufberater, Pagination, „Alle zurücksetzen"). Andere Collections/Produkte/Kategorien:
       normale Navigation. */
    root.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
      var a = e.target.closest('a[href]');
      var url = a ? pjaxUrlOf(a) : '';
      if (!url) { return; }
      e.preventDefault();
      var source = a.classList.contains('lmm-pagination__link') ? 'pagination' : 'filter';
      /* Obere (kompakte) Pagination: Scrollposition halten — Zweck ist gerade das Blättern OHNE
         zur Ergebnisliste zu springen. Untere Pagination scrollt wie bisher zu den Ergebnissen. */
      var keepScroll = !!a.closest('.lmm-pagination--top');
      /* Anker für die Nach-Swap-Korrektur: die umgebende Facette (stabiler als der Wert-Link,
         dessen Zähler sich ändern kann), sonst das Element selbst. */
      var anchorBox = a.closest('details') || a;
      pjaxNavigate(url, { source: source, sig: signatureOf(a), keepScroll: keepScroll, anchorTop: anchorBox.getBoundingClientRect().top });
    });

    /* C1b) Prefetch: Hover/Fokus/Touch auf einem Filterlink lädt die Ziel-Sections schon vor
       dem Klick in den Cache (mouseover bubbelt, pointerenter nicht). Zwischen Hover und Klick
       liegen typischerweise 150–400 ms — der Klick trifft dann meist den Cache und swappt sofort.
       Fehler bleiben still: der Klick fällt auf Live-Fetch bzw. normale Navigation zurück. */
    if (MAIN_SECTION_ID) {
      var prefetchFrom = function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        var url = a ? pjaxUrlOf(a) : '';
        if (!url || cacheGet(url) || pendingFetch.has(url)) { return; }
        fetchSections(url).then(null, function () {});
      };
      root.addEventListener('mouseover', prefetchFrom, { passive: true });
      root.addEventListener('touchstart', prefetchFrom, { passive: true });
      root.addEventListener('focusin', prefetchFrom);
    }

    /* C2) Sortierung: GET-Form per PJAX statt Reload. */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-lmm-sort]');
      if (!sel) { return; }
      var form = sel.closest('form');
      if (!form) { return; }
      var action = (form.getAttribute('action') || window.location.pathname).split('?')[0];
      var params = new URLSearchParams(new FormData(form));
      params.delete('page');
      if (params.get('sort_by') === 'manual') { params.delete('sort_by'); }
      var qsStr = params.toString();
      pjaxNavigate(action + (qsStr ? '?' + qsStr : ''), { source: 'sort' });
    });

    /* C2b) Preis-Range-Form (min/max) per PJAX statt Reload. Leere Felder werden weggelassen
       (kein leerer ?…gte=); ohne JS submittet die Form normal (Fallback bleibt). */
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form.lmf-range')) { return; }
      e.preventDefault();
      var action = (form.getAttribute('action') || window.location.pathname).split('?')[0];
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') { params.append(k, v); } });
      params.delete('page');
      var qsStr = params.toString();
      /* Facette der Preis-Form als Anker — hält die Position nach dem Swap. */
      var det = form.closest('details');
      var t = det ? det.querySelector('.lmf__title') : null;
      pjaxNavigate(action + (qsStr ? '?' + qsStr : ''), {
        source: 'filter',
        anchorKey: t ? norm(t.textContent) : '',
        anchorTop: det ? det.getBoundingClientRect().top : undefined
      });
    });

    /* C3) Zurück/Vor. */
    window.addEventListener('popstate', function () {
      pjaxNavigate(window.location.href, { push: false, source: 'pop' });
    });
  } else {
    /* Ohne fetch/pushState: Sortier-Form klassisch absenden (No-JS-Verhalten bleibt erhalten). */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-lmm-sort]');
      if (sel && sel.form) { sel.form.submit(); }
    });
  }

  /* =====================================================================
     C4) Energielabel-Modal — Klick aufs E-Badge einer Karte öffnet DASSELBE
     Label wie auf der PDP. Der Inhalt wird aus den Daten-Attributen des Buttons
     gebaut: Tier A = offizielles EPREL-PNG + Links (mit Lade-Fehler-Fallback),
     Tier B = EU-Optik-Karte aus Produktdaten. Bindung per Delegation auf document
     -> überlebt PJAX-Swaps (das Modal-Shell liegt außerhalb #lmmMain). Markup/Tier-
     Logik spiegeln sections/lmm-pdp-details.liquid — bei Änderungen dort nachziehen.
     ===================================================================== */
  function initEnergyModal() {
    var modal = document.getElementById('lmm-energy-modal');
    if (!modal) return;
    var body = modal.querySelector('[data-energy-body]');
    if (!body) return;
    var lastTrigger = null;

    /* Klassenfarben EU-Skala A–G [Hintergrund, Schrift] — 1:1 wie PDP. */
    var EEK = {
      A: ['#00a651', '#ffffff'], B: ['#50b848', '#ffffff'], C: ['#bfd730', '#1d1f24'],
      D: ['#fff200', '#1d1f24'], E: ['#fdb913', '#1d1f24'], F: ['#f37021', '#ffffff'],
      G: ['#ed1c24', '#ffffff']
    };
    var SCALE = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
    /* ENERG-Flaggen-Logo (EU 2017/1369) — statisch, 1:1 aus dem PDP-Markup. KEIN QR. */
    var ENERG_SVG = '<svg class="lmm-eulabel__energ" viewBox="0 0 200 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><rect x="0" y="3" width="44" height="30" fill="#003399"/><path d="M22.0,5.5L22.4,6.9L23.9,6.9L22.7,7.7L23.2,9.1L22.0,8.3L20.8,9.1L21.3,7.7L20.1,6.9L21.6,6.9Z" fill="#FFCC00"/><path d="M27.2,6.9L27.7,8.3L29.2,8.3L28.0,9.1L28.4,10.5L27.2,9.7L26.1,10.5L26.5,9.1L25.3,8.3L26.8,8.3Z" fill="#FFCC00"/><path d="M31.1,10.8L31.5,12.1L33.0,12.1L31.8,13.0L32.3,14.4L31.1,13.5L29.9,14.4L30.4,13.0L29.2,12.1L30.6,12.1Z" fill="#FFCC00"/><path d="M32.5,16.0L32.9,17.4L34.4,17.4L33.2,18.2L33.7,19.6L32.5,18.8L31.3,19.6L31.8,18.2L30.6,17.4L32.1,17.4Z" fill="#FFCC00"/><path d="M31.1,21.2L31.5,22.6L33.0,22.6L31.8,23.5L32.3,24.9L31.1,24.0L29.9,24.9L30.4,23.5L29.2,22.6L30.6,22.6Z" fill="#FFCC00"/><path d="M27.2,25.1L27.7,26.5L29.2,26.5L28.0,27.3L28.4,28.7L27.2,27.9L26.1,28.7L26.5,27.3L25.3,26.5L26.8,26.5Z" fill="#FFCC00"/><path d="M22.0,26.5L22.4,27.9L23.9,27.9L22.7,28.7L23.2,30.1L22.0,29.3L20.8,30.1L21.3,28.7L20.1,27.9L21.6,27.9Z" fill="#FFCC00"/><path d="M16.8,25.1L17.2,26.5L18.7,26.5L17.5,27.3L17.9,28.7L16.8,27.9L15.6,28.7L16.0,27.3L14.8,26.5L16.3,26.5Z" fill="#FFCC00"/><path d="M12.9,21.2L13.4,22.6L14.8,22.6L13.6,23.5L14.1,24.9L12.9,24.0L11.7,24.9L12.2,23.5L11.0,22.6L12.5,22.6Z" fill="#FFCC00"/><path d="M11.5,16.0L11.9,17.4L13.4,17.4L12.2,18.2L12.7,19.6L11.5,18.8L10.3,19.6L10.8,18.2L9.6,17.4L11.1,17.4Z" fill="#FFCC00"/><path d="M12.9,10.8L13.4,12.1L14.8,12.1L13.6,13.0L14.1,14.4L12.9,13.5L11.7,14.4L12.2,13.0L11.0,12.1L12.5,12.1Z" fill="#FFCC00"/><path d="M16.7,6.9L17.2,8.3L18.7,8.3L17.5,9.1L17.9,10.5L16.7,9.7L15.6,10.5L16.0,9.1L14.8,8.3L16.3,8.3Z" fill="#FFCC00"/><text x="52" y="29" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="27" fill="#003399">ENERG</text><path d="M150 5 L150 31 L173 31 L186 18 L173 5 Z" fill="#003399"/><path d="M156 10 L170 10 L163 17 L172 17 L157 31 L162 20 L154 20 Z" fill="#ffffff"/></svg>';

    function el(tag, cls, txt) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (txt != null) n.textContent = txt;
      return n;
    }
    function isHttp(u) { return /^https?:\/\//i.test(u || ''); }
    function ceilWatt(w) {
      var n = parseFloat(String(w == null ? '' : w).replace(',', '.'));
      if (!isFinite(n) || n <= 0) return null;
      return Math.ceil(n);
    }

    /* Tier A: offizielles EPREL-Label-PNG + Links; Lade-Fehler -> Fallback (Badge + Hinweis). */
    function buildTierA(d) {
      var png = 'https://eprel.ec.europa.eu/api/products/lightsources/' + encodeURIComponent(d.eprel) + '/labels?format=PNG';
      var pdf = 'https://eprel.ec.europa.eu/api/products/lightsources/' + encodeURIComponent(d.eprel) + '/labels?format=PDF';
      var frag = document.createDocumentFragment();

      var fig = el('figure', 'lmm-elabel__official');
      var img = new Image();
      img.src = png;
      img.alt = 'Offizielles EU-Energielabel (EPREL) — Energieeffizienzklasse ' + d.eek;
      img.width = 425; img.height = 850; img.loading = 'lazy'; img.decoding = 'async';
      fig.appendChild(img);
      fig.appendChild(el('figcaption', 'lmm-elabel__src', 'Offizielles EU-Energielabel aus der EPREL-Datenbank.'));
      frag.appendChild(fig);

      var fb = el('div', 'lmm-elabel__fallback'); fb.hidden = true;
      var col = EEK[d.eek] || EEK.G;
      var badge = el('span', 'lmm-eek lmm-eek--lg', d.eek);
      badge.style.background = col[0]; badge.style.color = col[1];
      fb.appendChild(badge);
      fb.appendChild(el('p', 'lmm-modal__text', 'Energieeffizienzklasse ' + d.eek + ' (EU-Skala A–G). Das offizielle Label ließ sich gerade nicht laden — bitte über die Links unten öffnen.'));
      frag.appendChild(fb);
      var onfail = function () { fig.hidden = true; fb.hidden = false; };
      img.addEventListener('error', onfail);
      if (img.complete && img.naturalWidth === 0) onfail();

      frag.appendChild(el('p', 'lmm-modal__text', 'Energieeffizienzklasse ' + d.eek + ' auf der EU-Skala A (effizient) bis G.'));

      var links = [];
      if (isHttp(d.doc)) links.push(['Produktdatenblatt', d.doc]);
      if (isHttp(d.eprelLink)) links.push(['EPREL-Eintrag', d.eprelLink]);
      links.push(['Energielabel als PDF', pdf]);
      var p = el('p', 'lmm-modal__links');
      links.forEach(function (lk, i) {
        if (i) p.appendChild(document.createTextNode(' · '));
        var a = el('a', null, lk[0]);
        a.href = lk[1]; a.target = '_blank'; a.rel = 'noopener';
        p.appendChild(a);
      });
      frag.appendChild(p);
      return frag;
    }

    /* Tier B: EU-Optik-Karte aus Produktdaten — KEIN offizielles Label, KEIN QR, KEIN EPREL-Link. */
    function buildTierB(d) {
      var frag = document.createDocumentFragment();
      var wrap = el('div', 'lmm-eulabel');
      wrap.innerHTML = ENERG_SVG; /* statisch/vertrauenswürdig */
      if (d.vendor) wrap.appendChild(el('p', 'lmm-eulabel__supplier', d.vendor));
      wrap.appendChild(el('hr', 'lmm-eulabel__rule'));

      var chart = el('div', 'lmm-escale__chart');
      chart.setAttribute('role', 'img');
      chart.setAttribute('aria-label', 'Energieeffizienzklasse ' + d.eek + ' auf der EU-Skala A (effizient) bis G');
      SCALE.forEach(function (c, i) {
        var col = EEK[c];
        var row = el('div', 'lmm-escale__row' + (c === d.eek ? ' is-active' : ''));
        var bar = el('span', 'lmm-escale__bar', c);
        bar.style.background = col[0]; bar.style.color = col[1];
        bar.style.width = (i * 9 + 46) + '%';
        row.appendChild(bar);
        if (c === d.eek) row.appendChild(el('span', 'lmm-escale__pointer', c));
        chart.appendChild(row);
      });
      wrap.appendChild(chart);
      wrap.appendChild(el('hr', 'lmm-eulabel__rule'));

      var foot = el('div', 'lmm-eulabel__foot');
      var kwh = ceilWatt(d.watt);
      if (kwh != null) {
        var k = el('div', 'lmm-eulabel__kwh');
        k.appendChild(el('b', null, String(kwh)));
        k.appendChild(el('span', null, 'kWh/1000h'));
        foot.appendChild(k);
      }
      foot.appendChild(el('span', 'lmm-eulabel__reg', '2019/2015'));
      wrap.appendChild(foot);
      frag.appendChild(wrap);

      frag.appendChild(el('p', 'lmm-escale__note', 'Darstellung auf Basis vorhandener Produktdaten (Energieeffizienzklasse ' + d.eek + ', EU-Skala A bis G). Kein offizielles EU-Energielabel.'));
      return frag;
    }

    function fill(btn) {
      var d = {
        eek: (btn.getAttribute('data-eek') || '').toUpperCase(),
        eprel: (btn.getAttribute('data-eprel') || '').trim(),
        eprelLink: btn.getAttribute('data-eprel-link') || '',
        doc: btn.getAttribute('data-doc') || '',
        vendor: (btn.getAttribute('data-vendor') || '').trim(),
        watt: btn.getAttribute('data-watt') || ''
      };
      /* Fail-closed: keine Energieklasse erfinden. Ungültiges/fehlendes data-eek -> nicht rendern. */
      if (!EEK[d.eek]) return false;
      body.innerHTML = '';
      body.appendChild(/^\d+$/.test(d.eprel) ? buildTierA(d) : buildTierB(d));
      return true;
    }

    function onKey(e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function openModal(btn) {
      /* Ungültige/fehlende Klasse -> Modal NICHT öffnen (keine erfundene Klasse). */
      if (!fill(btn)) return;
      lastTrigger = btn;
      modal.hidden = false;
      var c = modal.querySelector('.lmm-modal__close');
      if (c) c.focus();
      document.addEventListener('keydown', onKey);
    }
    function closeModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      lastTrigger = null;
    }

    /* Delegation: E-Badge öffnet; Close-Button/Backdrop schließen. */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-energy-open]');
      if (opener) { e.preventDefault(); openModal(opener); return; }
      if (e.target.closest('[data-energy-close]')) { closeModal(); }
    });
  }

  /* =====================================================================
     C6) Filter-Erklärungen — Klick auf den „Info"-Auslöser klappt das Erklär-Panel unter
     der Filterüberschrift auf/zu, OHNE das <details>-Accordion umzuschalten
     (preventDefault auf den Summary-Klick). Ist der Filter zugeklappt, wird er
     zusätzlich geöffnet, damit das Panel sichtbar ist. Delegiert auf document →
     überlebt PJAX-Swaps. Markup: Snippet lmm-filter-explain (data-lmm-explain).
     ===================================================================== */
  document.addEventListener('click', function (e) {
    var trg = e.target.closest('[data-lmm-explain]');
    if (!trg) return;
    e.preventDefault();
    var det = trg.closest('details');
    if (det && !det.open) det.open = true;
    var box = det ? det.querySelector('.lmf__explainbox') : null;
    if (!box) return;
    var open = trg.getAttribute('aria-expanded') === 'true';
    trg.setAttribute('aria-expanded', open ? 'false' : 'true');
    box.hidden = open;
  });

  /* Schließt der Nutzer den Filter über die Summary-Zeile, das Erklär-Panel zurücksetzen
     (verhindert aria-expanded-Desync zwischen Button und Panel). Das 'toggle'-Event bubbelt
     nicht → Capture-Phase auf document (greift auch nach PJAX-Swaps, nur bei .lmf__explainbox). */
  document.addEventListener('toggle', function (e) {
    var det = e.target;
    if (!det || det.tagName !== 'DETAILS' || det.open) return;
    var box = det.querySelector('.lmf__explainbox');
    var trg = det.querySelector('[data-lmm-explain]');
    if (box) box.hidden = true;
    if (trg) trg.setAttribute('aria-expanded', 'false');
  }, true);

  /* =====================================================================
     C7) Erklär-Chips auf der Produktkarte — „?" im Chip öffnet ein Popup mit
     Kurzerklärung und Ratgeberlink. Markup: lmm-filter-explain part:'chip'.
     Desktop: Mouseover (mit kurzer Nachlaufzeit, damit die Maus ins Popup wandern
     kann). Touch/Tablet: Klick — die Hover-Logik wird auf Geräten ohne echten Hover
     bewusst NICHT registriert, sonst öffnet der erste Tap und der folgende Klick
     schließt sofort wieder. Delegiert auf document → überlebt PJAX-Swaps.
     ===================================================================== */
  (function () {
    var offen = null, timer = null;
    var hatHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

    function schliessen() {
      if (!offen) return;
      offen.pop.hidden = true;
      offen.pop.style.transform = '';
      offen.pop.classList.remove('is-left');
      offen.trg.setAttribute('aria-expanded', 'false');
      offen = null;
    }
    var chipPool = null, chipTplEl = null, chipPopSeq = 0;
    function holeChipPop(trg) {
      var pop = trg.nextElementSibling;
      if (pop && pop.className && pop.className.indexOf('sp__pop') !== -1) {
        if (!pop.id) pop.id = 'lmm-cpop-existing-' + (++chipPopSeq);
        if (trg.getAttribute('aria-describedby') !== pop.id) trg.setAttribute('aria-describedby', pop.id);
        return pop;
      }
      var key = trg.getAttribute('data-lmm-chipq');
      if (!key) return null;
      if (!chipPool || !chipTplEl || !chipTplEl.isConnected) {
        chipTplEl = document.querySelector('template[data-lmm-chip-pool]');
        chipPool = (chipTplEl && chipTplEl.content) ? chipTplEl.content : null;
      }
      var vorlage = chipPool ? chipPool.querySelector('[data-lmm-chip-pop="' + key + '"]') : null;
      if (!vorlage) return null;
      pop = vorlage.cloneNode(true);
      var safeKey = String(key).replace(/[^a-zA-Z0-9_-]/g, '-');
      var popId = 'lmm-cpop-' + safeKey + '-' + (++chipPopSeq);
      pop.id = popId;
      pop.setAttribute('role', 'tooltip');
      trg.setAttribute('aria-describedby', popId);
      trg.insertAdjacentElement('afterend', pop);
      return pop;
    }
    function oeffnen(trg) {
      if (offen && offen.trg === trg) return;
      var pop = holeChipPop(trg);
      if (!pop || pop.className.indexOf('sp__pop') === -1) return;
      schliessen();
      pop.classList.remove('is-left');
      pop.hidden = false;
      trg.setAttribute('aria-expanded', 'true');
      offen = { trg: trg, pop: pop };
      /* Schritt 1 — grobe Seite: .lmm-coll clippt horizontal, ragt das Popup rechts aus dem
         Container, wird es rechtsbuendig zum Chip gesetzt. */
      pop.style.transform = '';
      var wrap = trg.closest('.lmm-coll');
      if (wrap) {
        var r = pop.getBoundingClientRect(), g = wrap.getBoundingClientRect();
        if (r.right > g.right - 4) pop.classList.add('is-left');
      }
      /* Schritt 2 — Feinkorrektur gegen den Bildschirm. Auf schmalen Viewports sitzt der Chip
         teils so weit links, dass auch die rechtsbuendige Variante herausragt (am 2026-08-14
         bei 375px gemessen: 65px links ausserhalb). Dann horizontal zurueckschieben. */
      var rand = 8, vw = document.documentElement.clientWidth, r2 = pop.getBoundingClientRect(), v = 0;
      if (r2.left < rand) v = rand - r2.left;
      else if (r2.right > vw - rand) v = (vw - rand) - r2.right;
      /* translateX statt margin: bei rechtsbuendiger Lage (left:auto/right:0) haette margin-left
         keine Wirkung — am 2026-08-14 auf 375px gemessen (Popup blieb 65px ausserhalb). */
      if (v) pop.style.transform = 'translateX(' + Math.round(v) + 'px)';
    }

    document.addEventListener('click', function (e) {
      var trg = e.target.closest('[data-lmm-chipq]');
      if (trg) {
        e.preventDefault();
        if (offen && offen.trg === trg) schliessen(); else oeffnen(trg);
        return;
      }
      if (!e.target.closest('.sp__pop')) schliessen();
    });

    if (hatHover) {
      document.addEventListener('mouseover', function (e) {
        var trg = e.target.closest('[data-lmm-chipq]');
        if (trg) { clearTimeout(timer); oeffnen(trg); return; }
        if (offen && e.target.closest('.sp__pop') === offen.pop) clearTimeout(timer);
      });
      document.addEventListener('mouseout', function (e) {
        if (!offen) return;
        var zu = e.relatedTarget;
        if (zu && zu.closest && (zu.closest('[data-lmm-chipq]') === offen.trg ||
                                 zu.closest('.sp__pop') === offen.pop)) return;
        clearTimeout(timer);
        timer = setTimeout(schliessen, 180);
      });
    }

    /* Tastatur: Tab öffnet, Escape schließt und gibt den Fokus zurück. */
    document.addEventListener('focusin', function (e) {
      var trg = e.target.closest('[data-lmm-chipq]');
      if (trg) oeffnen(trg);
      else if (offen && !e.target.closest('.sp__pop')) schliessen();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !offen) return;
      var t = offen.trg;
      schliessen();
      if (t) t.focus();
    });
  })();

  /* =====================================================================
     D) Initiale Initialisierung
     ===================================================================== */
  syncView();
  initPriceBox();
  initSliders();
  updateMobileCount();
  initEnergyModal();
  document.addEventListener('lmm:cards-replaced', function () {
    syncView();
    initPriceBox();
    if (compareRefresh) compareRefresh();
  });

  /* Info-Dialog des Betriebsart-Schnellfilters („Wie erkenne ich mein Vorschaltgerät?").
     Delegiert auf document -> überlebt die PJAX-Section-Swaps ohne Re-Init. Natives
     <dialog>.showModal() liefert Escape + Fokusfalle; der Fokus-Rücksprung zum Auslöser
     wird hier gesetzt. Ohne JS bleibt der Block voll bedienbar (die Filterkarten sind
     echte Links) — nur die Hinweisbox öffnet dann nicht. Das ist KEINE Filterlogik. */
  (function initBallastInfoDialog() {
    if (window.__lmmTbqfInfoInit) return;
    window.__lmmTbqfInfoInit = true;
    var lastTrigger = null;

    document.addEventListener('click', function (e) {
      var open = e.target.closest && e.target.closest('[data-lmm-tbqf-open]');
      if (open) {
        var dlg = document.getElementById('tbqfDialog');
        if (!dlg) return;
        e.preventDefault();
        lastTrigger = open;
        if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
        var first = dlg.querySelector('[data-lmm-tbqf-close]');
        if (first) first.focus();
        return;
      }
      var close = e.target.closest && e.target.closest('[data-lmm-tbqf-close]');
      if (close) {
        var d = close.closest('dialog');
        if (d) { if (typeof d.close === 'function') { d.close(); } else { d.removeAttribute('open'); } }
        return;
      }
      /* Klick auf den Backdrop schließt ebenfalls (Klick liegt dann auf dem dialog selbst). */
      if (e.target && e.target.id === 'tbqfDialog' && typeof e.target.close === 'function') {
        e.target.close();
      }
    });

    /* Fokus zurück zum Auslöser — greift auch bei Escape (dialog feuert 'close'). */
    document.addEventListener('close', function (e) {
      if (e.target && e.target.id === 'tbqfDialog' && lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }, true);
  })();

  /* Paket K (26.07.2026) — mobile Verdichtung der Kategorie. Delegiert auf document,
     überlebt damit PJAX-Section-Swaps ohne Re-Init. Ohne JS: Intro bleibt 2-zeilig
     geklemmt (Inhalt steht im DOM), der Betriebsart-Block bleibt mobil eingeklappt —
     beides nicht funktionskritisch, die Filter selbst sind echte Links im Drawer. */
  (function initMobileCondense() {
    if (window.__lmmMobileCondenseInit) return;
    window.__lmmMobileCondenseInit = true;

    document.addEventListener('click', function (e) {
      var it = e.target.closest && e.target.closest('[data-lmm-intro-toggle]');
      if (it) {
        var hero = it.closest('.cat-hero');
        if (!hero) return;
        var opened = hero.classList.toggle('intro-open');
        it.setAttribute('aria-expanded', opened ? 'true' : 'false');
        var t = it.querySelector('.intro-more__t');
        if (t) t.textContent = opened ? 'Weniger anzeigen' : 'Mehr anzeigen';
        return;
      }
      var bt = e.target.closest && e.target.closest('[data-lmm-tbqf-toggle]');
      if (bt) {
        var sec = bt.closest('.tbqf');
        if (!sec) return;
        var open = sec.classList.toggle('is-open');
        bt.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      /* Paket A (26.07.2026): generische Mobil-Akkordeons der unteren Collection-
         Bloecke (SEO-Text, Passende Kategorien/Ratgeber, Kategorien-Baum). Nur
         mobil togglen — auf Desktop sind die Buttons per CSS inert. */
      var mb = e.target.closest && e.target.closest('[data-lmm-macc]');
      if (mb && window.matchMedia('(max-width: 860px)').matches) {
        var card = mb.closest('.lmm-macc');
        if (!card) return;
        var mopen = card.classList.toggle('is-open');
        mb.setAttribute('aria-expanded', mopen ? 'true' : 'false');
      }
    });

    /* aria-expanded an die Viewport-Realitaet angleichen (Desktop = offen). */
    function syncMaccAria() {
      var mobile = window.matchMedia('(max-width: 860px)').matches;
      var cards = document.querySelectorAll('.lmm-macc');
      for (var i = 0; i < cards.length; i++) {
        var b = cards[i].querySelector('[data-lmm-macc]');
        if (b) b.setAttribute('aria-expanded', (!mobile || cards[i].classList.contains('is-open')) ? 'true' : 'false');
      }
    }
    syncMaccAria();

    /* „Mehr anzeigen" nur zeigen, wenn das Intro mobil wirklich geklemmt ist —
       bei kurzen Texten bleibt der Button versteckt. */
    var condenseMq = window.matchMedia('(max-width: 860px)');
    function syncIntroMore() {
      var btns = document.querySelectorAll('[data-lmm-intro-toggle]');
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        var hero = btn.closest('.cat-hero');
        var intro = hero ? hero.querySelector('.intro') : null;
        if (!hero || !intro) { btn.hidden = true; continue; }
        if (!condenseMq.matches) { btn.hidden = false; continue; } /* Desktop: CSS versteckt ohnehin */
        if (hero.classList.contains('intro-open')) { btn.hidden = false; continue; }
        btn.hidden = intro.scrollHeight <= intro.clientHeight + 2;
      }
    }
    syncIntroMore();
    if (condenseMq.addEventListener) condenseMq.addEventListener('change', function () { syncIntroMore(); syncMaccAria(); });
    window.addEventListener('resize', function () { window.requestAnimationFrame(syncIntroMore); });
  })();
})();
